import { YapContext } from "@sc07-canvas/chat";
import React, { lazy } from "react";
import { memo } from "react";

import { useAppContext } from "../../contexts/AppContext";

const Maybe = ({
  if: check,
  element: Elem,
  children,
}: React.PropsWithChildren<{
  if: boolean;
  element: (props: React.PropsWithChildren) => React.ReactElement;
}>) => {
  if (!check) {
    return children;
  }

  return <Elem>{children}</Elem>;
};

/**
 * load YapContext if env var is setup
 *
 * TODO: dynamically load
 */
export const ChatContext = memo(({ children }: React.PropsWithChildren) => {
  return (
    <Maybe if={__DEV_CHAT__} element={YapContext}>
      {children}
    </Maybe>
  );
});

const YapperLoader = lazy(() => import("@sc07-canvas/chat/Yapper"));

export const Chat = () => {
  const { loadChat } = useAppContext();

  return (
    <React.Suspense>
      {__DEV_CHAT__ && loadChat && <YapperLoader />}
    </React.Suspense>
  );
};
